import { takeEvery, put } from "redux-saga/effects";
import { request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import {store} from "../../store";
export default function* watcherDeleteProductCategorySaga() {
    yield takeEvery("DELETE_PRODUCT_CATEGORY", workerSaga);
}

function* workerSaga(action) {
    try {
        yield put({ type: "DISPLAY_LOADER" });
        let payload = {};
        var url= 'api/Admin/delete-product-category?id=' + action.payload;
        yield request("post", action.payload, url).then(response => {
            payload = response;
        });
        toast.success(payload)
        const formatUrl = `api/Admin/get-product-category/${
          store.getState().persistReducer.companyId
        }`;
        yield request("get", payload, formatUrl).then(response => {
            payload = response;
        });

        yield put({ type: "PRODUCT_CATEGORY_LIST", payload: payload})
        yield put({ type: "DISPLAY_LOADER", payload: payload })
    } catch (e) {
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        yield put({ type: "DISPLAY_LOADER" });
        console.log("delete-product-category-saga",e)
        console.log("delete-product-category-saga",e.response)
        console.log(e.response)
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
    }
}
